import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function anexosReducer(state = initialState.anexos, action){
    switch(action.type) {
        case types.PESQUISAR_ANEXOS:
            return action.anexos;
        case types.ANEXAR:
            return action.anexos;
        default:
            return state;
    }
}




/** WEBPACK FOOTER **
 ** ./src/components/reduces/anexosReducer.js
 **/